import axios, { getOnce } from '@/plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async index(leadId: number) {
        if (!leadId) {
            throw new InvalidPayload('Lead ID not provided.');
        }

        const response = await getOnce(`v1/leads/${leadId}/task-events`);
        if (response === null) {
            return null;
        }

        return response.data;
    },

    async show(id: number, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/task-events/${id}`, {
            params: payload,
        });

        return response.data.data;
    },

    async complete(id: number): Promise<unknown> {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.put(`v2/tasks/${id}`, { completed: true });

        return response.data.data;
    },
};
